<div class="referral" style="padding: 3%;">
    <h2 mat-dialog-title>{{ data.message }}</h2>
    
    <mat-dialog-actions>
      <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="onSuccessResponse()">Ok</button>
    </mat-dialog-actions>
    </div>